import { render, staticRenderFns } from "./item-view.vue?vue&type=template&id=ba2f8002"
import script from "./item-view.vue?vue&type=script&lang=ts"
export * from "./item-view.vue?vue&type=script&lang=ts"
import style0 from "./item-view.vue?vue&type=style&index=0&id=ba2f8002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports